/**
 * Set which face for render.
 */
export enum RenderFace {
  /** Render front face. */
  Front,
  /** Render back face. */
  Back,
  /** Render double face. */
  Double
}
